const colors = require('./tailwind.colors.config');


module.exports = {
    content: [
        './src/**/*.{js,ts,jsx,tsx}',
        './node_modules/@devotel/design-system/**/*.{js,ts,jsx,tsx}',
    ],
    theme: {
        extend: {
            colors,
            screens: {
                xsm: '376px',
                xxl: '1441px',
                msm: '424px',
                lmd: '991px',
            },
            maxWidth: {
                xxl: '1458px',
            },
            backgroundImage: {
                'primary-surface-gradient': 'linear-gradient(90deg, #C9CFF5 0%, #FFFFFF 100%)',
            },
        },
    },
    plugins: [
        function ({ addComponents }) {
            addComponents({
                '.btn-primary': {
                    backgroundColor: '#233AC6',
                    color: '#ffffff',
                    padding: '0.75rem ',
                    borderRadius: '0.5rem',
                    fontWeight: '500',
                    transition: 'all 0.2s',
                    position: 'relative',
                    '&:hover': {
                        backgroundColor: '#3d4bc2',
                    },
                    '&:disabled': {
                        opacity: 0.24,
                        cursor: 'not-allowed',
                    },
                },
            })
        },
    ],
};
